import { getSolutionCategoryPageLink } from "template-store/services/solution-links-service";
import Tag from "@mondaydotcomorg/monday-ui-components/dist/Tag";
import { componentStyles } from "./template-header.scss";

const TemplateHeader = (props) => {
  const { templateName, templateCategoriesData, categoriesPrefixText } = props;

  const renderCategories = () => {
    return templateCategoriesData.map((categoryData, index) => {
      return (
        <div className="category-wrapper" key={index}>
          <Tag tagName={categoryData.label} tagLink={getSolutionCategoryPageLink(categoryData.value)} />
        </div>
      );
    });
  };

  return (
    <div className="template-header">
      <div className="template-data-wrapper">
        <h1 className="template-name"> {templateName} Template</h1>
        <div className="template-details-wrapper">
          <div className="template-categories">
            <div className="category-prefix-text">{categoriesPrefixText}</div>
            <div className="categories-wrapper"> {renderCategories()}</div>
          </div>
        </div>
      </div>
      <style jsx>{componentStyles}</style>
    </div>
  );
};

TemplateHeader.defaultProps = {};

export default TemplateHeader;
